import type { LearnerType } from '@/types'
import type { PreferenceProfile } from './types'
import { getPreferredLearningStyle } from './getPreferredLearningStyle'

export type SocialLearningMode = 'collaborative' | 'balanced' | 'independent'

export interface SocialLearningProfile {
  mode: SocialLearningMode
  label: string
  cue: string
  band: number
  confidence: number
  evidenceCount: number
}

const learnerTypeByStyle = {
  imagination: 'story',
  visual: 'game',
  expression: 'social',
  challenge: 'challenge',
} as const satisfies Record<ReturnType<typeof getPreferredLearningStyle>, LearnerType>

export function getSocialLearningProfile(preference: PreferenceProfile): SocialLearningProfile {
  const interaction = preference.tendencies?.interaction

  if (!interaction) {
    return {
      mode: 'balanced',
      label: '弹性协作',
      cue: '独立与协作切换',
      band: 3,
      confidence: 0,
      evidenceCount: 0,
    }
  }

  if (interaction.band <= 2) {
    return {
      mode: 'collaborative',
      label: '协作联结',
      cue: '交流后行动',
      band: interaction.band,
      confidence: interaction.confidence,
      evidenceCount: interaction.evidenceCount,
    }
  }

  if (interaction.band >= 4) {
    return {
      mode: 'independent',
      label: '自主探索',
      cue: '独立思考优先',
      band: interaction.band,
      confidence: interaction.confidence,
      evidenceCount: interaction.evidenceCount,
    }
  }

  return {
    mode: 'balanced',
    label: '弹性协作',
    cue: '独立与协作切换',
    band: interaction.band,
    confidence: interaction.confidence,
    evidenceCount: interaction.evidenceCount,
  }
}

export function getPreferredLearnerType(preference: PreferenceProfile): LearnerType {
  const social = getSocialLearningProfile(preference)
  if (social.mode === 'collaborative' && social.evidenceCount >= 2) return 'social'
  return learnerTypeByStyle[getPreferredLearningStyle(preference)]
}
